import React from 'react';
import { FaHistory } from 'react-icons/fa';

const ago = (ts) => {
  const mins = Math.round((Date.now() - ts) / 60000);
  if (mins < 1) return 'hace un momento';
  if (mins < 60) return `hace ${mins} min`;
  const hrs = Math.round(mins / 60);
  return hrs < 24 ? `hace ${hrs} h` : `hace ${Math.round(hrs / 24)} d`;
};

/** Aviso de borrador recuperado (ver useDraft). */
export default function DraftBanner({ restoredAt, onDiscard }) {
  if (!restoredAt) return null;
  return (
    <div role="status" className="flex flex-wrap items-center gap-3 rounded-2xl bg-live-soft ring-1 ring-live/25 px-4 py-3 text-sm text-fg">
      <FaHistory className="text-live" aria-hidden />
      <span className="flex-1 min-w-[200px]">Recuperamos los cambios que no habías guardado ({ago(restoredAt)}). Revísalos y guarda para conservarlos.</span>
      <button type="button" onClick={onDiscard} className="h-8 rounded-full px-3.5 text-[13px] font-semibold bg-raised text-fg hover:bg-line focus:outline-none focus-visible:ring-2 focus-visible:ring-live">Descartar cambios</button>
    </div>
  );
}
